import css from './index.module.scss';
import EfScrollAni from '@/efscrollani';
import { useRouter } from 'next/router';
import A from '../../comps/A';
import B from '../../comps/B';
import C from '../../comps/C';
import D from '../../comps/D';
import E from '../../comps/E';
import F from '../../comps/F';
import G from '../../comps/G';
import H from '../../comps/H';
import I from '../../comps/I';
import J from '../../comps/J';
// import K from '../../comps/K';
// import L from '../../comps/L';
import M from '../../comps/M';
import N from '../../comps/N';
import Tab from '../../comps/Tab';
import { useProductPageStatus } from '../../ProductProvider';
import { IPageStatus } from '../../config/IPageStatus';
import TC from '../../comps/TC';

const Overview: React.FC = () => {
    const { locale = 'us' } = useRouter();
    const pageStatus = useProductPageStatus();
    // const IS_NA: boolean = ['us', 'ca'].includes(locale);
    const IS_EU = ['eu', 'uk', 'de', 'fr', 'it', 'es', 'nl'].includes(locale);

    if (typeof window !== 'undefined') {
        if (!window?.AniContainer) {
            window.AniContainer = new EfScrollAni();
        }
    }

    return (
        <div className={`rapid-pro-overview ${css.page}`}>
            <A />
            {pageStatus === IPageStatus.LAUNCH && <B />}
            <C />
            <D />
            <E />
            <div className="range">
                <Tab />
                <F />
                {locale !== 'ph' && <G />}
                <H />
                <I />
            </div>
            <J />
            {/* {IS_NA && <K />} */}
            {/* {IS_NA && <L />} */}
            <M />
            <N />
            {IS_EU && <TC />}
        </div>
    );
};

export default Overview;
